module.exports = __webpack_public_path__ + "img/Close.f1feafb4.svg";